<script>
export default {
    name: "AutopsyReport",

    props: {

        patient: Object,
        autopsyReport: Array,
        showModal: Boolean,
    },

    methods: {

        printAutopsyReport() {
            let queryString = `?PatientID=${this.patient.patientID}`;
            window.open(
                `/morgue/autopsy-report-print${queryString}`, 
                '_blank', `LabPrint`, 
                "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        },
    }
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-3/4 w-3/4">
      <template v-slot:title>
        <h5 class="font-bold text-sm">Autopsy Report</h5>
      </template>
      <template v-slot:modal-body>
        <div class="w-full overflow-auto flex flex-wrap items-center">
            <div class="w-full flex flex-wrap my-3">
                <div class="w-1/4 p-1">
                    <h5 class="font-medium text-sm">Patient: {{ patient.patient }}</h5>
                </div>
                <div class="w-1/4 p-1">
                    <h5 class="font-medium text-sm">MRN : {{ patient.patientID }}</h5>
                </div>
                <div class="w-1/4 p-1">
                    <h5 class="font-medium text-sm">IP File No: {{ patient.ipfileno || `-` }}</h5>
                </div>
                <div class="w-1/4 p-1">
                    <h5 class="font-medium text-sm">OP File No: {{ patient.opfileno || `-` }}</h5>
                </div>
            </div>
            <table class="table">
                <thead class="bg-blue-500 text-white text-xs">
                    <tr>
                        <th class="p-tiny">Bed</th>
                        <th class="p-tiny">Date Admitted</th>
                        <th class="p-tiny">Autopsy Date</th>
                        <th class="p-tiny">Header</th>
                        <th class="p-tiny">Ref</th>
                        <th class="p-tiny">Details</th>
                        <th class="p-tiny">Comment</th>
                        <th class="p-tiny">Done By</th>
                    </tr>
                </thead>
                <tbody class="bg-gray-100">
                    <tr v-for="(auto,idx) in autopsyReport" :key="idx">
                        <td class="p-tiny">{{ auto.bed }}</td>
                        <td class="p-tiny">{{ auto.date_Admitted | dateFormat }}</td>
                        <td class="p-tiny">{{ auto.autopsy_Date | dateFormat }}</td>
                        <td class="p-tiny">{{ auto.header }}</td>
                        <td class="p-tiny">{{ auto.ref }}</td>
                        <td class="p-tiny">{{ auto.details }}</td>
                        <td class="p-tiny">{{ auto.comment }}</td>
                        <td class="p-tiny">{{ auto.doneBy || `-` }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
      </template>
      <template v-slot:modal-footer>
        <button
            @click.prevent="printAutopsyReport"
            class="btn-info btn-sm text-xs rounded mr-6">
                <i class="fa fa-print"></i> Print</button>
        <button class="btn-danger btn-sm text-xs rounded" 
            @click.prevent="$emit(`closeModal`)">
                <i class="fa fa-times"></i> Close</button>
      </template>
    </tail-modal>
</template>